// import PDFViewer from "pdf-viewer-reactjs";

const PDFComponent = ({ pdfUrl, baseUrl, prodTestUrl }) => {
  const fileUrl = prodTestUrl ? prodTestUrl + pdfUrl : baseUrl + pdfUrl;

  // Use a key to trigger re-rendering on URL change
  const viewerKey = fileUrl; // This can be used to force a re-mount on url change

  return (
    // <PDFViewer
    //   key={viewerKey}
    //   document={{ url: fileUrl }}
    // />
    "pdf"
  );
};

export default PDFComponent;
